// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  // DialogContentText,
  Tooltip,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField,
  Checkbox,
  Button,
  Table,
  TableRow,
  TableCell,
  Divider,
  // Divider,
  // FormControlLabel,
  // Switch,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
// import MDBadge from "theme/components/MDBadge";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";

function TradeMarketingHomePage() {
  const pageTitle = "Trade Marketing - Dashboard";
  usePageTitle(pageTitle);
  const navigate = useNavigate();
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mb={5}>
        <Card sx={{ height: "100%", marginTop: "0px" }}>
          <MDBox p={3}>
            <MDBox align="center">
              <MDBox mb={3}>
                <MDTypography variant="h6" fontSize={48}>
                  <Icon>ads_click</Icon>
                </MDTypography>
                <MDTypography variant="h6" fontSize={18}>
                  Trade Marketing
                </MDTypography>
                <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                  Run multiple marketing promotions seamlessly. Monitor, track and measure results.
                  Get realtime reports, insights, retail performance and distribution.
                </MDTypography>
                <MDBox mt={3} align="center">
                  <Grid container spacing={2} justifyContent="center" sx={{ margin: "0 auto" }}>
                    <Grid item xs={6} md={2} lg={2} onClick={() => navigate("/campaigns")}>
                      <Card sx={{ height: "100%", marginTop: "0px" }} elevation={5}>
                        <MDBox p={1}>
                          <MDTypography variant="h6" fontSize={24}>
                            <Icon>receipt</Icon>
                          </MDTypography>
                          <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                            Field
                            <br />
                            Sales
                          </MDTypography>
                        </MDBox>
                      </Card>
                    </Grid>
                    <Grid item xs={6} md={2} lg={2} onClick={() => navigate("/trade-marketing/promotions/bill-back")}>
                      <Card sx={{ height: "100%", marginTop: "0px" }} elevation={5}>
                        <MDBox p={1}>
                          <MDTypography variant="h6" fontSize={24}>
                            <Icon>poll</Icon>
                          </MDTypography>
                          <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                            Bill Back
                            <br />
                            Promos
                          </MDTypography>
                        </MDBox>
                      </Card>
                    </Grid>
                    <Grid item xs={6} md={2} lg={2} onClick={() => navigate("/campaigns")}>
                      <Card sx={{ height: "100%", marginTop: "0px" }} elevation={5}>
                        <MDBox p={1}>
                          <MDTypography variant="h6" fontSize={24}>
                            <Icon>checklist</Icon>
                          </MDTypography>
                          <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                            Retail
                            <br />
                            Audits
                          </MDTypography>
                        </MDBox>
                      </Card>
                    </Grid>
                    <Grid item xs={6} md={2} lg={2} onClick={() => navigate("/trade-marketing/promotions/display-win")}>
                      <Card sx={{ height: "100%", marginTop: "0px" }} elevation={5}>
                        <MDBox p={1}>
                          <MDTypography variant="h6" fontSize={24}>
                            <Icon>leaderboard</Icon>
                          </MDTypography>
                          <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                            Display
                            <br />& Win
                          </MDTypography>
                        </MDBox>
                      </Card>
                    </Grid>
                    {/* <Grid item xs={6} md={2} lg={2}>
                        <Card sx={{ height: "100%", marginTop: "0px" }} elevation={5}>
                          <MDBox p={1}>
                            <MDTypography variant="h6" fontSize={24}>
                              <Icon>people</Icon>
                            </MDTypography>
                            <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                              Retail<br/>On-boarding
                            </MDTypography>
                          </MDBox>
                        </Card>
                      </Grid> */}
                    <Grid item xs={6} md={2} lg={2} onClick={() => navigate("/trade-marketing/promotions/product-sampling")}>
                      <Card sx={{ height: "100%", marginTop: "0px" }} elevation={5}>
                        <MDBox p={1}>
                          <MDTypography variant="h6" fontSize={24}>
                            <Icon>thumb_up</Icon>
                          </MDTypography>
                          <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                            Product
                            <br />
                            Sampling
                          </MDTypography>
                        </MDBox>
                      </Card>
                    </Grid>
                  </Grid>
                </MDBox>
              </MDBox>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default TradeMarketingHomePage;
